import { useTranslation } from "react-i18next";
import { motion } from "framer-motion";
import { Check, X } from "lucide-react";
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "@/components/ui/table";
export const ComparisonTable = () => {
  const {
    t
  } = useTranslation("landing");
  const comparisonData = [{
    feature: t("comparison.items.access.feature"),
    traditional: {
      status: false,
      description: t("comparison.items.access.traditional")
    },
    offertio: {
      status: true,
      description: t("comparison.items.access.offertio")
    }
  }, {
    feature: t("comparison.items.translation.feature"),
    traditional: {
      status: false,
      description: t("comparison.items.translation.traditional")
    },
    offertio: {
      status: true,
      description: t("comparison.items.translation.offertio")
    }
  }, {
    feature: t("comparison.items.finding.feature"),
    traditional: {
      status: false,
      description: t("comparison.items.finding.traditional")
    },
    offertio: {
      status: true,
      description: t("comparison.items.finding.offertio")
    }
  }, {
    feature: t("comparison.items.notification.feature"),
    traditional: {
      status: false,
      description: t("comparison.items.notification.traditional")
    },
    offertio: {
      status: true,
      description: t("comparison.items.notification.offertio")
    }
  }];
  const containerVariants = {
    hidden: {
      opacity: 0
    },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.1
      }
    }
  };
  const itemVariants = {
    hidden: {
      opacity: 0,
      y: 20
    },
    visible: {
      opacity: 1,
      y: 0,
      transition: {
        duration: 0.5
      }
    }
  };
  return <section className="py-14 px-4 bg-gray-50">
      <div className="container mx-auto max-w-6xl">
        <motion.div className="text-center mb-12" initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }}>
          <h2 className="text-2xl md:text-3xl font-bold mb-6">
            {t('comparison.title')}
          </h2>
          
        </motion.div>

        <motion.div className="overflow-hidden rounded-xl shadow-lg border border-gray-100" variants={containerVariants} initial="hidden" whileInView="visible" viewport={{
        once: true
      }}>
          <Table>
            <TableHeader>
              <TableRow className="bg-primary/5">
                <TableHead className="w-1/3 py-3 text-left text-gray-700 font-bold text-sm">{t('comparison.feature')}</TableHead>
                <TableHead className="w-1/3 py-3 text-left text-gray-700 font-bold text-sm">{t('comparison.traditional')}</TableHead>
                <TableHead className="w-1/3 py-3 text-left font-bold text-primary text-sm">
                  Offertio
                </TableHead>
              </TableRow>
            </TableHeader>
            <TableBody>
              {comparisonData.map((item, index) => <motion.tr key={index} className={index % 2 === 0 ? "bg-white" : "bg-gray-50"} variants={itemVariants}>
                  <TableCell className="font-medium py-3 text-sm">{item.feature}</TableCell>
                  <TableCell className="py-3">
                    <div className="flex items-start">
                      <div className="flex-shrink-0 mr-2 mt-1">
                        <X className="h-4 w-4 text-red-500" />
                      </div>
                      <div className="text-gray-600 text-xs">{item.traditional.description}</div>
                    </div>
                  </TableCell>
                  <TableCell className="py-3">
                    <div className="flex items-start">
                      <div className="flex-shrink-0 mr-2 mt-1">
                        <Check className="h-4 w-4 text-green-500" />
                      </div>
                      <div className="text-gray-700 font-medium text-xs">{item.offertio.description}</div>
                    </div>
                  </TableCell>
                </motion.tr>)}
            </TableBody>
          </Table>
        </motion.div>

        <motion.div className="mt-6 text-center" initial={{
        opacity: 0
      }} whileInView={{
        opacity: 1
      }} transition={{
        delay: 0.6
      }} viewport={{
        once: true
      }}>
          
        </motion.div>
      </div>
    </section>;
};